import * as React from 'react'
import {
  Button,
  Divider,
  Dropdown,
  DropdownItemProps,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Message
} from 'semantic-ui-react'
import { common } from '../../../../../utils/common'
import { homeService, userService } from '../../../../../services'
import { DropdownProps } from 'semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown'
import { InputOnChangeData } from 'semantic-ui-react/dist/commonjs/elements/Input/Input'
import { toast } from 'react-toastify'
import * as queryString from 'querystring'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import { vietqr } from '../../../../../utils/vietqr'
import { QrCodeImage } from '../../../../components/QrCodeImage'
import _ = require('lodash')

type DepositProps = {
  location?: {
    search?: string,
  }
}
type DepositState = {
  isLoading: boolean,
  bank: string,
  amount: number,
  depositSuccess: boolean,
  depRequest?: IDepositRequest,
  disabledNotify: boolean,
  bankInfoList: IBankInfo[],
  validBankInfoOptions: DropdownItemProps[]
}
export default class Deposit extends React.Component<DepositProps> {
  state: DepositState = {
    isLoading: false,
    bank: '',
    amount: 0,
    depositSuccess: false,
    disabledNotify: true,
    bankInfoList: [],
    validBankInfoOptions: [],
  }

  componentDidMount() {
    if (this.props.location && this.props.location.search) {
      const query = queryString.parse(this.props.location.search.replace('?', ''))
      if (query.amount) {
        this.setState({amount: query.amount})
      }
    }
    homeService.getBankInfoList()
      .then(value => this.setState({
        bankInfoList: value,
        validBankInfoOptions: _.chain(value)
          .filter('active')
          .sortBy(['priority'])
          .map(function (bankInfo: IBankInfo): DropdownItemProps {
            return {value: bankInfo.code, text: bankInfo.name}
          }).value()
      }))
  }

  onChangeAmount = (event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
    event.preventDefault()
    this.setState({
      amount: Number(data.value.replace(/[\D\s\._\-]+/g, ''))
    })
  }

  onChangeBank = (event: React.KeyboardEvent<HTMLElement>, data: DropdownProps) => {
    event.preventDefault()
    this.setState({
      bank: data.value
    })
  }

  onClickDepositMoney = async () => {
    let {bank} = this.state
    if (this.state.amount === 0 || !bank) {
      toast.error('Vui lòng điền số tiền hoặc phương thức thanh toán !')
      return
    }
    this.setState({
      amount: Number((this.state.amount / 1000).toFixed(0)) * 1000,
      isLoading: true,
    },            () => {
      const depositInfo = {username: 'abc', amount: this.state.amount, bank: bank}
      userService.requestDeposit(depositInfo).then(res => {
        this.setState({
          isLoading: false,
          depositSuccess: true,
          depRequest: res,
          disabledNotify: false,
        })
      }).catch(error => {
        this.setState({
          isLoading: false
        })
        toast.error(error.messege)
      })
    })
  }

  onNotifyButton = () => {
    this.setState({
      disabledNotify: true,
    })
    const {depRequest} = this.state
    if (depRequest) {
      userService.notifyDeposit(depRequest)
    }
  }

  renderDepInfo = (depRequest: IDepositRequest) => {
    const bankInfo = common.getActiveBank(depRequest.bank, this.state.bankInfoList)
    const {disabledNotify} = this.state
    const totalAmount = common.calculateFee(depRequest.amount, depRequest.feeFactor)
    const content = `M${depRequest.id} mua steam`
    const srcQrCode = bankInfo
      ? vietqr.generateUrl(bankInfo.code, bankInfo.account, totalAmount, content, bankInfo.accountName)
      : ''

    return (
      <div>
        <Message color="green">
          Thành công! Mã chuyển tiền của bạn là: M{depRequest.id}
          <br/> Số tiền nạp: <strong>{depRequest.amount.toLocaleString('vn')}</strong>
          <br/> Phí nạp tiền: {depRequest.feeFactor ? `${(depRequest.feeFactor * 100).toLocaleString('vn')} %` : '0'}
          <br/> Tổng tiền nạp + phí: <strong>{totalAmount.toLocaleString('vn')}</strong>
        </Message>
        <Message color="blue">

          Bạn vui lòng chuyển khoản với
          <br/> Số tiền: <strong>{totalAmount.toLocaleString('vn')}</strong>
          <br/> Nội dung: <strong>{content}</strong>
          <CopyToClipboard
            text={`M${depRequest.id} mua steam`}
          >
            <Button size="mini" color="green">Sao chép</Button>
          </CopyToClipboard>

          <Grid columns={2} stackable={true}>
            <Grid.Row>
              {srcQrCode &&
                <Grid.Column>
                  <br/> Quét mã QR để thanh toán
                  <QrCodeImage src={srcQrCode}/>
                </Grid.Column>
              }
              <Grid.Column>
                {srcQrCode && <Divider>Hoặc</Divider>}
                <br/> Chuyển khoản đến số tài khoản:
                <Message>
                  {bankInfo &&
                    <div dangerouslySetInnerHTML={{__html: bankInfo.information}}/>
                  }
                </Message>
                <CopyToClipboard
                  text={bankInfo ? bankInfo.account : ''}
                >
                  <Button size="mini" color="green">Sao chép số tài khoản</Button>
                </CopyToClipboard>
                <br/>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <br/> Tài khoản của bạn sẽ được cập nhật trong vòng 5 phút. Sau khi chuyển tiền thành công
          5 phút nếu thấy số dư tài khoản không đổi, bạn vui lòng liên hệ với chúng tôi. Xin chân thành cảm ơn!
          <br/> Sau khi bạn chuyển tiền thành công, vui lòng bấm vào
          nút bên dưới để xác nhận chuyển tiền nhé! Xin cảm ơn!
          <br/>
          <br/>
          <Button primary={true} disabled={disabledNotify} onClick={this.onNotifyButton}>Đã chuyển tiền</Button>
        </Message>

      </div>)
  }

  render() {
    let {isLoading, depositSuccess, depRequest, amount, validBankInfoOptions} = this.state
    return (
      <Form loading={isLoading}>
        <Grid columns={2}>
          <Header as="h1">
            <Icon name="settings"/>
            <Header.Content>
              Nạp tiền
              <Header.Subheader>Nạp tiền vào tài khoản bằng chuyển khoản</Header.Subheader>
            </Header.Content>
          </Header>
          {depositSuccess && depRequest &&
            this.renderDepInfo(depRequest)
          }
          <Grid.Row>
            <Grid.Column width={6}>
              <label>Số tiền</label>
            </Grid.Column>
            <Grid.Column width={12}>
              <Input
                required={true}
                placeholder="100.000 VND"
                onChange={this.onChangeAmount}
                type={'text'}
                value={amount.toLocaleString('en-US')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <label>Phương thức thanh toán</label>
            </Grid.Column>
            <Grid.Column width={12}>
              <Dropdown selection={true} options={validBankInfoOptions} onChange={this.onChangeBank}/>
            </Grid.Column>
          </Grid.Row>
        </Grid><br/>
        <Grid.Row>
          <Grid.Column width={6}>
            <Button animated={true} color="red" onClick={this.onClickDepositMoney}>
              <Button.Content visible={true}>Nạp tiền</Button.Content>
              <Button.Content hidden={true}>
                <Icon name="dollar" color="yellow"/>
              </Button.Content>
            </Button>
          </Grid.Column>
        </Grid.Row>

      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/User/containers/Deposit.tsx